<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-04-26 18:19:27
 * @Description: 报警信息
 * @LastEditors: Please set LastEditors
-->
<template>
  <el-tabs
    v-drag
    class="position-absolute alarm_info"
    :class="setSemitransparent ? 'semitransparent' : ''"
    v-model="activeName"
    type="card"
  >
    <el-tab-pane label="SIS报警" name="first">
      <SISAlarm></SISAlarm>
    </el-tab-pane>
    <el-tab-pane label="围栏报警" name="second">
      <fenceAlarm></fenceAlarm>
    </el-tab-pane>
    <el-tab-pane label="周界报警" name="third"></el-tab-pane>
    <el-tab-pane label="门禁报警" name="fourth"></el-tab-pane>
  </el-tabs>
</template>
<script>
const SISAlarm = () => {
  return import('./components/SISAlarm')
}
const fenceAlarm = () => {
  return import('./components/fenceAlarm')
}

export default {
  props: ['setSemitransparent'],
  components: { fenceAlarm, SISAlarm },
  data() {
    return {
      activeName: 'first',
    }
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/semitransparent.scss';
.alarm_info {
  height: 500px;
  width: 750px;
  top: 48px;
  background-color: #ffffff;
  border-radius: 4px;
  z-index: 99;
}
/deep/.el-tabs__content,
/deep/.el-tab-pane {
  height: calc(100% - 35px);
}
/deep/.el-tabs__header {
  margin-bottom: 0px;
}
/deep/.el-tabs__item {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
}
/deep/ .el-table {
  thead th {
    padding: 0px;
  }
  &__body-wrapper {
    height: calc(100% - 25px);
    overflow-y: scroll;
  }
}

</style>
